export default "__VITE_ASSET__B37IV6GS__"